import {
  hasAnySim,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroNao,
  isPerguntaOutroSim,
} from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta09Model,
  ConsultaSeguimentoPergunta09TrazPraVoceEnum,
} from './model-consultaSeguimentoPergunta09'

const pergunta09TrazPraVoceEnumValues = Object.values(ConsultaSeguimentoPergunta09TrazPraVoceEnum)

export function isPergunta09TrazPraVoceAllNao(value: ConsultaSeguimentoPergunta09Model): boolean {
  const isExemplosAllNao = isAllNao(value?.PERGUNTA_09_TRAZ_PRA_VOCE, pergunta09TrazPraVoceEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllNao && isPerguntaOutroNao(value?.OUTRO)
  }

  return isExemplosAllNao
}

export function hasPergunta09TrazPraVoceAnySim(value: ConsultaSeguimentoPergunta09Model): boolean {
  return hasAnySim(value?.PERGUNTA_09_TRAZ_PRA_VOCE) || isPerguntaOutroSim(value?.OUTRO)
}

export function prunePergunta09(value: ConsultaSeguimentoPergunta09Model): ConsultaSeguimentoPergunta09Model {
  const pruned: ConsultaSeguimentoPergunta09Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_09_HEADER: value.PERGUNTA_09_HEADER,
    PERGUNTA_09_TRAZ_PRA_VOCE: value.PERGUNTA_09_TRAZ_PRA_VOCE,
    OUTRO: value.OUTRO,
  }

  if (hasPergunta09TrazPraVoceAnySim(value)) {
    pruned.PERGUNTA_09_SO_PARA_MOSTRAR = value.PERGUNTA_09_SO_PARA_MOSTRAR
  }

  return pruned
}
